import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { environment } from '@environments/environment';
import { MsalGuard } from '@azure/msal-angular';
import { AuthGuard } from '@core/guards/auth.guard';

const routes: Routes = [
	{
		path: 'login',
		loadChildren: () => import('./modules/login/login.module').then((m) => m.LoginModule),
	},
	{
		path: 'home',
		loadChildren: () => import('./modules/igo-admin-panel/igo-admin-panel.module').then((m) => m.IgoAdminPanelModule),
		canActivate: [environment.requireSSO ? MsalGuard : AuthGuard],
	},
	{
		path: '**',
		redirectTo: 'login',
	},
];

@NgModule({
	imports: [RouterModule.forRoot(routes)],
	exports: [RouterModule],
})
export class AppRoutingModule {}
